import React from 'react';
import styled from 'styled-components';

import { border1, green } from 'utils/style/colors';
import { FormEvent } from 'react';

export const StyledTextarea = styled('textarea')`
  border: ${border1};
  transition: 0.3s all ease;
  border-radius: 10px;
  padding: 0.5rem !important;
  background-color: var(--exact-white);
  margin: 0.5rem 0;

  @media only screen and (max-width: 900px) {
    margin: 0.1rem 0;
  }
  box-sizing: border-box;
  min-height: 3rem;
  resize: vertical;
  height: inherit;
  outline: none;
  &:hover {
    border-color: ${green};
  }
  &:focus {
    border-color: ${green};
    box-shadow: 0 0 0 2px rgba(50, 200, 182, 0.3);
  }
  &::placeholder {
    font-weight: bolder;
  }
`;

interface IComponentProps
  extends React.DetailedHTMLProps<
    React.TextareaHTMLAttributes<HTMLTextAreaElement>,
    HTMLTextAreaElement
  > {
  id: string;
  label?: string;
  wrapperClassName?: string;
  wrapperStyle?: any;
  forwardRef?:
    | ((instance: HTMLTextAreaElement | null) => void)
    | React.RefObject<HTMLTextAreaElement>
    | null;
}

function autoGrow(event: FormEvent<HTMLElement>) {
  event.currentTarget.style.height = '1px';
  const a = event.currentTarget.scrollHeight;
  event.currentTarget.style.height = 'auto';
  const b = event.currentTarget.scrollHeight;
  event.currentTarget.style.height = Math.min(a, b) + 2 + 'px';
}

const Textarea: React.FunctionComponent<IComponentProps> = ({
  id,
  label,
  wrapperClassName,
  wrapperStyle,
  forwardRef,
  ...restProps
}) => {
  return (
    <div className={wrapperClassName} style={wrapperStyle}>
      {label && <label htmlFor={id}>{label}</label>}
      <StyledTextarea
        id={id}
        ref={forwardRef as any}
        onInput={autoGrow}
        onChange={autoGrow}
        onFocus={autoGrow}
        onChangeCapture={autoGrow}
        {...restProps}
      />
    </div>
  );
};

export default React.memo(Textarea);
